// @noflow

import PlayerManager from '../PlayerManager';
import { PlayerEvent } from '../../../player/utils';

const GEO_ZIP_URL = '//p-geo.movetv.com/geo';

class BlackoutManager extends PlayerManager {
  constructor(playerDelegate, blackoutVisible, accountZipCode) {
    super(playerDelegate, blackoutVisible, accountZipCode);

    this._blackoutVisible = blackoutVisible;
    this._accountZipCode = accountZipCode;
    this.geoData = {};
    this.isBlackout = false;
  }

  get enabled() {
    return true;
  }

  get events() {
    return {
      [PlayerEvent.SourceLoaded]: () => {
        this.getGeoZip();
        this.startCheckQvtBlackoutStatus();
      },
      [PlayerEvent.Destroy]: () => {
        // need to refactor player so that sourceunloaded is used?
        this.endCheckQvtBlackoutStatus();
      },
      [PlayerEvent.Seek]: () => {
        this.getQvtBlackoutStatus();
      },
    };
  }

  // This works correctly only under US VPN!
  getGeoZip() {
    fetch(process.env.IS_BROWSER ? GEO_ZIP_URL : 'http:' + GEO_ZIP_URL)
      .then(response => response.json())
      .then(payload => {
        this.geoData = payload;
      });
  }

  async getQvtBlackoutStatus() {
    if (!this._delegate._player.playerView) {
      return;
    }

    let blackOutCurrentState = false;
    const currentPlaybackTime = process.env.IS_BROWSER
      ? this._delegate._player.playerView.getCurrentTime()
      : await this._delegate._player.getCurrentPlayerTime();
    const { qvtPayload } = this._delegate._player.props;
    const { playback_info } = qvtPayload;
    const anchorTime =
      playback_info && playback_info.linear_info && playback_info.linear_info.anchor_time
        ? playback_info.linear_info.anchor_time
        : 0;
    const zipCode = this.geoData.zip_code;
    if (
      !playback_info ||
      !playback_info.regional_blackouts ||
      (!zipCode && !this._accountZipCode)
    ) {
      return;
    }
    const { zip_codes, start_time, stop_time } = playback_info.regional_blackouts[0];
    if (!zip_codes || !zip_codes.length) {
      return;
    }
    if (
      (zip_codes.includes(zipCode) || zip_codes.includes(this._accountZipCode)) &&
      (currentTime > parseInt(start_time) && currentTime < parseInt(stop_time))
    ) {
      blackOutCurrentState = true;
    }
    if (typeof this._blackoutVisible === 'function' && this.isBlackout !== blackOutCurrentState) {
      this.isBlackout = blackOutCurrentState;
      this._blackoutVisible(blackOutCurrentState);
    }
  }

  startCheckQvtBlackoutStatus() {
    this.getQvtBlackoutStatus();
    this.checkingQvtBlackoutStatus = setInterval(() => {
      this.getQvtBlackoutStatus();
    }, 1000);
  }

  endCheckQvtBlackoutStatus() {
    clearInterval(this.checkingQvtBlackoutStatus);
  }
}

export default BlackoutManager;
